import BootstrapModal from '../../components/BootstrapModal';
import {ProgressSpinner} from "primereact/progressspinner";

const competencyForm = ({modal,competencyID,competencyName,competencyDefination,weight,active,onSubmit,onHide,isLoading}) => {
    console.log(competencyID);
    const customHandleSubmit = e =>{
        e.preventDefault();

       const formJson = {
           "competencyID":e.target.competencyID.value,
           "competencyName":e.target.competencyName.value,
           "competencyDefination":e.target.competencyDefination.value,
           "weight":e.target.weight.value,
           "active":e.target.active.checked,
           "addedBy":e.target.addedBy.value
       }
       console.log(formJson);
       onSubmit(formJson)
    }

  return (
    <BootstrapModal headerText="Add Competency" size={30} visible={modal} onHide={onHide}>
                <form method='POST' className='mt-3' onSubmit={customHandleSubmit}>
                    <input type="hidden" name="competencyID" id='competencyID' defaultValue={competencyID}/>
                    <div className="form-outline mb-3">
                        <input type="competencyName" name='competencyName'
                            placeholder='Enter Competency Name..'
                            id="competencyName"
                            defaultValue={competencyName}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>      
                    <div className="form-outline mb-3">
                        <input type="competencyDefination" name='competencyDefination'
                            placeholder='Enter Competency Definition..'
                            id="competencyDefination"
                            defaultValue={competencyDefination}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>    
                    <div className="form-outline mb-3">
                        <input type="weight" name='weight'
                            placeholder='Enter RCL'
                            id="weight"
                            defaultValue={weight}
                            autoComplete="off" className="form-control" />
                        <span className='text-danger'></span>
                    </div>                       
                    <div className="form-group mb-3">
                        <div className="form-check">
                            <input                           
                            className="form-check-input" type="checkbox" name="active" id="active"  checked={active}/>
                            <label className="form-check-label" htmlFor="active">Active</label>
                        </div>
                    </div>

                    <input type="hidden" name='addedBy' id='addedBy' value="forhad"/>

                    {/* <button type='submit' className='btn btn-primary'>Save</button> */}
                    {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{competencyID === 0 ? 'Save' : 'Update'} </button>}
                </form>
            </BootstrapModal>
  )
}

export default competencyForm